/*
 * @Description:
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-11-24 11:29:47
 * @LastEditors: chenkang
 * @LastEditTime: 2022-01-17 18:07:02
 */
import Vue from 'vue'
/**权限指令**/
const has = Vue.directive('has', {
    inserted: function (el, binding, vnode) {
        // 获取页面按钮别名
        let menuAlias = vnode.data.attrs.menuAlias;
        /**判断权限中是否存在该别名 */
        if (!Vue.prototype.$_has(menuAlias)) {
            el.parentNode.removeChild(el);
        }
    }
});
// 权限检查方法
Vue.prototype.$_has = function (value) {
    if(localStorage.getItem("type") == "1"){
        return true
    }
    let isExist = false;
    let pageAuth=localStorage.getItem("pageAuth");
    if (!pageAuth) {
        return false;
    }
    let pageAuthArray = pageAuth.split(",");
    if (!pageAuthArray || pageAuthArray.length == 0) {
        return false;
    }
    if (pageAuthArray.includes(value)) {
        isExist = true;
    }
    return isExist;
};
export {has}



// WEBPACK FOOTER //
// ./src/common/util/btnPermissions.ts